import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import Button from "@/common/atoms/Button";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Grid } from "antd";
const MapBanner = React.lazy(() => import("./MapBanner"));

const HomeMap = () => {
  const { t } = useTranslation();
  const { countryBasedPropertyList } = useSelector(
    (state) => ({
      countryBasedPropertyList: state.property.countryBasedPropertyList
    }),
    shallowEqual
  );

  const memoizedPropertyExploreList = useMemo(
    () => countryBasedPropertyList,
    [countryBasedPropertyList]
  );
  const { sm } = Grid.useBreakpoint();

  return (
    <section className="mx-auto max-w-screen-xl w-full py-10">
      <div className="relative flex flex-col gap-6 items-center justify-center px-4 md:px-5">
        <div className="text-center">
          <p className="text-primary font-bold text-sm md:text-xl leading-[18px] tracking-normal text-center uppercase">
            {t("home.mapTitle")}
          </p>
          <h1 className="text-secondary font-bold text-sm md:text-2xl  leading-[46px] tracking-normal text-center">
            {t("home.mapDescription")}
          </h1>
        </div>
        {sm ? (
          <MapBanner
            className="h-[420px] mx-auto w-full max-w-screen-xl  rounded-xl overflow-hidden"
            properties={memoizedPropertyExploreList}
            isHome={true}
            zoom={2}
          />
        ) : null}

        <Link to="/property-listing">
          <Button className="h-12 !w-40" type="link">
            {t("home.exploreMap")}
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default HomeMap;
